import { useEffect, useRef, useState } from 'react'
import { useInViewOnce } from './useInViewOnce'
import { useNetworkAllowsPreload } from './useNetworkAllowsPreload'
const PLACEHOLDER = 'absolute inset-0 bg-gradient-to-br from-m1-surface via-m1-ground to-[#1a1626]'
function VideoFramePreview({ src, enabled, className = '' }) {
  const videoRef = useRef(null)
  const [tileRef, tileSeen] = useInViewOnce({ rootMargin: '0px' })
  const networkAllowed = useNetworkAllowsPreload()
  const [ready, setReady] = useState(false)
  const [failed, setFailed] = useState(false)
  const active = enabled && networkAllowed && tileSeen
  useEffect(() => {
    setReady(false)
    setFailed(false)
  }, [active, src])
  const primeFirstFrame = () => {
    const video = videoRef.current
    if (!video) return
    try {
      if (video.currentTime < 0.01) {
        video.currentTime = 0.05
      }
      video.pause()
      setReady(true)
    } catch {
      setFailed(true)
    }
  }
  return (
    <div ref={tileRef} className="absolute inset-0">
      {!active || failed ? (
        <div className={`${PLACEHOLDER} ${className}`} aria-hidden="true" />
      ) : (
        <>
          <video
            ref={videoRef}
            src={src}
            preload="metadata"
            muted
            playsInline
            aria-hidden="true"
            tabIndex={-1}
            className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-700 ${ready ? 'opacity-100' : 'opacity-0'} ${className}`}
            onLoadedData={primeFirstFrame}
            onLoadedMetadata={primeFirstFrame}
            onSeeked={primeFirstFrame}
            onError={() => setFailed(true)}
          />
          {!ready && <div className={PLACEHOLDER} aria-hidden="true" />}
        </>
      )}
    </div>
  )
}
export { VideoFramePreview as default }
